
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Ebene_2","data-name":"Ebene 2"}},[_c('g',{attrs:{"id":"Ebene_1-2","data-name":"Ebene 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M16.39 10.5h21.45v16.1a9.16 9.16 0 01-9.16 9.16h-3.13a9.16 9.16 0 01-9.16-9.16V10.5z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M25.92 35.29h3.18v7.15h-3.18z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M15.91 41.48h22.88v1.43H15.91z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M31.36 14.8l8.3 2c.34 2.56.69 5.13 1 7.69l-5.06 3.84-4.83-.92M22.76 14.8l-8.3 2c-.35 2.56-.69 5.13-1 7.69l5.07 3.84 4.82-.92"}})])])])
          )
        }
      }
    